import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Header, Divider, Statistic, Segment } from 'semantic-ui-react';

import * as AppActions from '../../actions';

import './Dashboard.css';

class Dashboard extends Component {
  componentDidMount() {
    this.props.setSectionTitle('');
    this.props.saveGTMEvent('Dashboard', 'Alexia');
  }

  render() {
    if (['NU'].includes(this.props.user.groups[0])) {
      return (
        <div className="container">
          <div
            className="Dashboard-segment"
            style={{ height: '50%', display: 'flex', alignItems: 'center' }}
          >
            <Segment basic style={{ width: '100%' }}>
              <Header as="h2" icon textAlign="center">
                <span role="img" aria-label="hello">
                  👋
                </span>
                <Header.Content>Welcome</Header.Content>
                <Header.Subheader>
                  Click the menu icon in the top left corner to get started.
                </Header.Subheader>
              </Header>
            </Segment>
          </div>
        </div>
      );
    }

    return (
      <div className="container">
        <div className="Dashboard-segment">
          <Segment basic raised>
            <Statistic.Group widths="four">
              <Statistic>
                <div className="statistic-widget-div">
                  <iframe
                    src="https://constellationagency.looker.com/embed/public/JQWtr8s6ZzbdjTkmQ2JtPQSGcjvCqpSC"
                    width="600"
                    height="338"
                    frameBorder="0"
                    title="campaign-total"
                    className="statistic-widget-iframe"
                  />
                </div>
                {/* <Statistic.Label>Campaigns</Statistic.Label> */}
              </Statistic>
              <Statistic>
                <div className="statistic-widget-div">
                  <iframe
                    src="https://constellationagency.looker.com/embed/public/qv4sGyXRqVW9MM95W5rkp7Qhy9KgcRXY"
                    width="600"
                    height="338"
                    frameBorder="0"
                    title="adset-total"
                    className="statistic-widget-iframe"
                  />
                </div>
                {/* <Statistic.Label>Ad Sets</Statistic.Label> */}
              </Statistic>
              <Statistic>
                <div className="statistic-widget-div">
                  <iframe
                    src="https://constellationagency.looker.com/embed/public/Qn8bDkh7YYyr99R4Tyq3XbXTDKvYhxQR"
                    width="600"
                    height="338"
                    frameBorder="0"
                    title="ad-total"
                    className="statistic-widget-iframe"
                  />
                </div>
                {/* <Statistic.Label>Ads</Statistic.Label> */}
              </Statistic>
              <Statistic>
                <div className="statistic-widget-div">
                  <iframe
                    src="https://constellationagency.looker.com/embed/public/t5tZpGVd8SMZrFv984tTRccrNKn6YPzk"
                    width="600"
                    height="338"
                    frameBorder="0"
                    style={{ position: 'relative', top: '26px' }}
                    title="team-member-total"
                    className="statistic-widget-iframe"
                  />
                </div>
                {/* <Statistic.Label>Team Members</Statistic.Label> */}
              </Statistic>
            </Statistic.Group>
          </Segment>
        </div>
        <Divider hidden />
        <div className="Dashboard-segment">
          <Segment basic raised>
            <Header as="h3" />
            <iframe
              id="dashboard-iframe"
              title="dashboard-count"
              src="https://constellationagency.looker.com/embed/public/NXrt86JzY5Z2MMVWw2w4QZ6xF6RgBpmJ"
              width="600"
              height="338"
              frameBorder="0"
            />
          </Segment>
        </div>
        <Divider hidden />
        <div className="Dashboard-segment">
          <Segment basic raised>
            <Header as="h3" />
            <iframe
              id="dashboard-iframe"
              title="dashboard-type"
              src="https://constellationagency.looker.com/embed/public/PtyP3SJYRg3zHJwT6TW36W9KDNJHpynZ"
              width="600"
              height="338"
              frameBorder="0"
            />
          </Segment>
        </div>
        <Divider hidden />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.js